import { urls } from './../config';
import { getToken, clearToken } from './tokenStorage';

const authFetch = (url, init) => {
    const headers = {
        'Content-Type': 'application/json',
        'X-Role': 'grader',
    };
    const token = getToken();
    if (token) {
        headers.Authorization = token;
    }
    return fetch(url, Object.assign({
        headers,
        credentials: 'include',
    }, init)).then(r => {
        if (r.ok) {
            return r.json();
        }
        if (r.status === 401 || r.status === 403) {
            clearToken();
            window.location = `${urls.login}`;
            return Promise.reject();
        }
        if (r.status === 405) {
            return Promise.reject({ status: r.status });
        }
        if (r.status === 422) {
            return r.json().then(errorJson => { errorJson.status = r.status; throw errorJson; });
        }
        throw new Error(`${r.status} ${r.statusText}`);
    });
}

export default authFetch;



// WEBPACK FOOTER //
// ./src/utils/authFetch.js